<template>
    <div>
        <v-dialog v-model="dialog_scanner" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">
            <!-- <v-btn @click="fn_hideScanner">Hide Scanner</v-btn> -->
        <!-- </v-dialog> -->
            <v-card flat>
                <v-toolbar flat>
                    <v-toolbar-side-icon @click="fn_hideScanner(false)"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

                    <v-toolbar-title>Items</v-toolbar-title>

                    <v-spacer></v-spacer>
                    <!-- <v-btn color="success" @click="fn_showUsbScanner">text</v-btn> -->
                    <v-btn small round-borders outline @click="fn_saveItems" v-if="items.length">Done</v-btn>

                    <v-menu>
                        <v-btn small slot="activator" icon>
                            <v-icon>more_vert</v-icon>
                        </v-btn>
                        <v-list nopadding>
                            <v-list-tile class="pr-0">
                                <v-list-tile-action style="text-align: right;">
                                    <v-checkbox v-model="usbScanner" @change="fn_changeScanner"></v-checkbox>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title>USB Scanner</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-menu>

                    <!-- <v-checkbox label="USB Scanner" v-model="usbScanner" @change="fn_changeScanner"></v-checkbox> -->
                </v-toolbar>

                <!-- {{ scannedBarcode }} -->

               <!-- <div style="height: 100px;">
                 <v-text-field
                    label=""
                    id="id"
                    v-model="scannedBarcode"
                    placeholder=" "
                ></v-text-field>
                <v-btn color="success" @click="fn_barcodeData(scannedBarcode)">Add</v-btn>
               </div> -->

                <v-card-text v-if="items.length" class="pa-0">
                    <template v-for="(item, index) in items">
                        <div class="mb-3" :key="index" :class="{'mt-2': index!=0}">
                            <v-list three-lines>
                                <v-list-tile class="pr-1">
                                    <v-list-tile-content @click="fn_editItem(item)">
                                        <v-list-tile-title>{{ item.productName }}</v-list-tile-title>
                                        <v-list-tile-sub-title><span light-opacity-color>Rate</span> &#8377; {{ item.rate }}</v-list-tile-sub-title>
                                        <v-list-tile-sub-title v-if="item.taxValue && item.taxAmount"><span light-opacity-color>GST</span> @{{item.taxValue}}% &#8377; {{ item.taxAmount }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="max-width: 100px;display: flex;flex-direction: row;">
                                        <button grey-back style="width:24px;height:30px" @click="fn_decreaseQty(item)">-</button> 
                                        <input style="border: 1px #ddd solid;padding: 2px 8px;width: 52px;" type="number" v-model="item.productVariants[0].qty" placeholder="Qty">
                                        <button grey-back style="width:24px;height:30px" @click="fn_increaseQty(item)">+</button>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list>
                            <!-- <v-layout row wrap>
                                <v-flex xs1 sm1 md1 @click="fn_editItem(item)">
                                    <v-btn icon small class="ma-0 pa-0 pr-3"><v-icon color="primary" font16>edit</v-icon></v-btn>
                                </v-flex>
                                <v-flex xs8 sm8 md8>
                                    <div>{{item.productName}}</div>
                                    <div v-if="item.rate"><span light-opacity-color>Rate</span> &#8377; {{ item.rate }}</div>
                                    <div v-if="item.taxValue && item.taxAmount"><span light-opacity-color>GST</span> @{{item.taxValue}}% &#8377; {{ item.taxAmount }}</div>
                                </v-flex>
                                <v-flex xs3 sm3 md3>
                                    
                                    <button>-</button> 
                                    <input style="border: 1px #ddd solid;padding: 2px 8px;" type="number" v-model="item.productVariants[0].qty" placeholder="Qty">
                                    <button>+</button>
                                    <div right-align>{{ item.productVariants[0].selectedUnit ? item.productVariants[0].selectedUnit.itemName : item.productVariants[0].primaryUnitName }}</div>
                                </v-flex>
                            </v-layout> -->

                            <v-divider v-if="items.length - 1 != index"></v-divider>
                        </div>
                    </template>
                </v-card-text>

                <v-card-text v-else>
                    <div class="pt-4 font16" style="margin-top: 50%;" center-align light-opacity-color>
                        No items added! <br><br>
                        Scan barcode to add item
                    </div>
                </v-card-text>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
let scannerListener;
export default{
    props:['closeDialog'],
    data(){	
		return{
			dialog_scanner: false,
            items:[],
            scannedBarcode:null,
            buffer:null,
            lastTime:null,
            usbScanner:false,
            productDataModel:{"groupId":null, "productId":null, "groupTypeId":null, "productName":null, "mrp":null, "rate":null, "description":null, "productVariants":[], "taxValue":null, "taxAmount":0, "hsnCode":null, "orderNumber":null, "grossAmount":0, "grossAmountAsPerMRP":0, "netAmount":0, "addOnsItems":[], "cessValue":null, "cessAmount":0, "taxCategoryId": null, "taxCategoryName": null, "defaultTaxValue":null, "defaultCessValue":null, "defaultHsnCode":null, "defaultTaxCategoryId":null, "defaultTaxCategoryName": null, "isCessApplicable":false, "taxableValue":null, "defaultSellingPrice":null, "defaultWholeSalePrice":null, "description":null}
        }
	},
    methods:{
        openDialogWeb: function () {
            if(!this.dialog_scanner){
                this.dialog_scanner = true;
                window.js_globals.fn_barcodeData = this.fn_barcodeData;
                window.js_globals.fn_barcodeScanUSB = this.fn_barcodeScanUSB;
                window.js_globals.fn_hideBarcodeScanner = this.fn_hideScanner;

                if(localStorage.getItem('usb_scanner')){
                    this.usbScanner = true;
                }

                // Remove Listener
                if(scannerListener){
                    document.removeEventListener("keydown", scannerListener);
                }

                let buffer = "";
                let lastTime = Date.now();
                let self = this;

                scannerListener = function(e) {
                    // alert('in');
                    const now = Date.now();

                    if (now - lastTime > 300) {
                        buffer = "";
                    }

                    if (e.key.length === 1) {
                        buffer += e.key;
                    }

                    if (e.key === "Enter") {
                        self.fn_barcodeData(buffer);
                        console.log("Scanned:", buffer);
                        buffer = "";
                    }

                    lastTime = now;
                }

                // Attach listener
                document.addEventListener("keydown", scannerListener);
            }


            // Attach listener
            // document.addEventListener("keydown", this.fn_usbScannerListener);
            if(!this.usbScanner){
                this.fn_showScanner();
            }
		},
		closeDialogWeb: function () {
			this.dialog_scanner = false;

            if(document.getElementById('s_btn')){
                setTimeout(() => {
                    document.getElementById('s_btn').style.position = 'fixed';
                    document.getElementById('s_btn').style.width = '100%';
                }, 500);

                setTimeout(() => {
                    document.getElementById('s_btn').style.position = 'static';
                }, 800);
            }

            // Remove Listener
            if(scannerListener){
                document.removeEventListener("keydown", scannerListener);
            }
		},
        fn_usbScannerListener: function(){
            const now = Date.now();
            this.testdata = now;

            // If time between keys is too large, reset buffer (human typing)
            if (now - this.lastTime > 30) {
                this.buffer = "";
            }

            // Ignore special keys
            if (e.key.length === 1) {
                this.buffer += e.key;
            }

            this.fn_barcodeData(this.buffer);

            // Scanner usually ends with Enter
            if (e.key === "Enter") {
                console.log("Scanned:", this.buffer);
                this.buffer = "";
            }

            this.lastTime = now;
        },

        fn_changeScanner: function(val){
            if(val){
                localStorage.setItem('usb_scanner', 1);
                this.fn_hideScanner(true);
            }
            else{
                this.fn_showScanner();
                localStorage.removeItem('usb_scanner');
            }
        },
        
        fn_showScanner: function () {
            let dataObj = {beepOn:true}
            this.postData('ShowScannerTest', dataObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_hideScanner: function (preventCloseDialog) {
            var self = this;
            this.postData('HideScannerTest', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
            if(!preventCloseDialog){
                this.closeDialog();
            }
        },

        fn_getProductData: function (barcode) {
            var self = this;
            this.getData('ProductByBarcode', barcode, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        let productData = JSON.parse(response);

			          	// if(productData.groupTypeId==101){
				        //   	self.fn_getSummary(productData.productId);
				       	// }

                        if(productData){
                            self.fn_bindData(productData);
                        }
                        else{
                            self.showToast('Barcode not add in item master');
                        }
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_bindData: function (productData) {
            let existingItemIndex = this.items.findIndex(item=>{return item.productId == productData.productId});
            
            if(existingItemIndex != -1){
                this.items[existingItemIndex].productVariants[0].qty = Number(this.items[existingItemIndex].productVariants[0].qty) + 1;
            }
            else{
                this.productDataModel = {"groupId":null, "productId":null, "groupTypeId":null, "productName":null, "mrp":null, "rate":null, "description":null, "productVariants":[], "taxValue":null, "taxAmount":0, "hsnCode":null, "orderNumber":null, "grossAmount":0, "grossAmountAsPerMRP":0, "netAmount":0, "addOnsItems":[], "cessValue":null, "cessAmount":0, "taxCategoryId": null, "taxCategoryName": null, "defaultTaxValue":null, "defaultCessValue":null, "defaultHsnCode":null, "defaultTaxCategoryId":null, "defaultTaxCategoryName": null, "isCessApplicable":false, "taxableValue":null, "defaultSellingPrice":null, "defaultWholeSalePrice":null, "description":null};
			
                if(!this.productDataModel.groupId){
                    this.productDataModel.baseTransactionListId = this.$parent.settings.transactionTypeId;
					this.productDataModel.baseTransactionNumber = this.$parent.Form.transactionData.mergeTransactionNumber;
                    this.productDataModel.groupId = this.guid();
                }
                this.productDataModel.groupTypeId = productData.groupTypeId;
                this.productDataModel.productId = productData.productId;
                this.productDataModel.productName = productData.name;
                this.productDataModel.productVariants = JSON.parse(JSON.stringify(productData.productVariants));

                this.productDataModel.productVariants.forEach( item => {
                    item.primaryUnitId = item.variantBaseUnitId;
                    item.primaryUnitName = item.unitName;
                    this.$set(item, 'qty', 1);

                    //setting pack quantity 1 in case of null or base variant
                    !item.packQuantity ? item.packQuantity = 1 : '';

                    if(item.secondaryUnitId && !item.selectedUnit){
                        item.selectedUnit = {};
                        item.selectedUnit.itemId = item.unitId;
                        item.selectedUnit.itemName = item.unitName;
                    }
                });

                this.productDataModel.mrp = productData.mrp;
                this.productDataModel.defaultSellingPrice = productData.sellingPrice;
                this.productDataModel.defaultWholeSalePrice = productData.wholeSalePrice;

                if(this.$parent.Form.transactionTypeData.tradingType == 1){
                    this.productDataModel.rate = productData.wholeSalePrice;
                }
                else{
                    this.productDataModel.rate = productData.sellingPrice;
                }

                this.productDataModel.taxValue = productData.taxValue;
                this.productDataModel.cessValue = productData.cessValue;
                this.productDataModel.hsnCode = productData.hsnCode;
                this.productDataModel.taxCategoryId = productData.taxCategoryId;
                this.productDataModel.taxCategoryName = productData.taxCategoryName;
                this.productDataModel.defaultTaxCategoryId = productData.taxCategoryId;
                this.productDataModel.isCessApplicable = productData.isCessApplicable;

                //saving default tax value for draft
                this.productDataModel.defaultTaxValue = productData.taxValue;
                this.productDataModel.defaultCessValue = productData.cessValue;

                this.productDataModel.purchaseRate = productData.purchaseRate;

                //charges in case of service item
                if(productData.groupTypeId==102){
                    this.productDataModel.rate = productData.charges;	
                }
                
                this.items.push(this.productDataModel);
            }
            
		},

        fn_editItem: function(item){
            this.fn_hideScanner();
            this.$parent.fn_editItem(JSON.parse(JSON.stringify(item)), null, null, null, true);
        },
        

        fn_barcodeData: function(barcode){
            this.$parent.Form.transactionTypeData.transactionTypeAddOns.forEach(item=> {
                this.productDataModel.addOnsItems.push(JSON.parse(JSON.stringify(item)));
            })

            let code = barcode.toString().trim();
            this.fn_getProductData(code);
            console.log(barcode);
        },

        fn_barcodeScanUSB: function(barcode){
            console.log(barcode);
            this.scannedBarcode = barcode;
            this.$parent.Form.transactionTypeData.transactionTypeAddOns.forEach(item=> {
                this.productDataModel.addOnsItems.push(JSON.parse(JSON.stringify(item)));
            })

            let code = barcode.toString().trim();
            this.fn_getProductData(code);
            console.log(barcode);
        },

        fn_saveItems: function(){
            let self = this;
            for(let i=0; i<this.items.length; i++){
                (function(itemIndex){
                    self.$parent.fn_saveItem(self.items[itemIndex], itemIndex, self.items.length, false, true);
                    if(itemIndex == self.items.length - 1){
                        self.fn_hideScanner();
                        self.closeDialog();
                    }
                }(i))
            }
        },

        fn_increaseQty: function(item){
            item.productVariants[0].qty++;
        },
        
        fn_decreaseQty: function(item){
            if(item.productVariants[0].qty>1){
                item.productVariants[0].qty--
            }
        }
    },
    // mounted: function(){
    //     window.js_globals.fn_barcodeData = this.fn_barcodeData;
    //     this.fn_showScanner();
    // }
}
</script>


// WEBPACK FOOTER //
// src/components/barcode/scanner.vue